import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import React from 'react';

function AccountViewDialog({ viewDialog, selectedView, handleViewDialog }) {
  console.log('selected view', selectedView);
  return (
    <>
      <Dialog open={viewDialog} onClose={handleViewDialog} fullWidth>
        <Grid
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '10px',
            padding: '10px'
          }}
        >
          <h2>
            {selectedView.refPatientName} is undergoing {selectedView.refTreatmentPlan}
          </h2>
        </Grid>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4} md={4}>
              <Typography variant="subtitle2" textAlign="left">
                TreatmentPlan
                <br />
              </Typography>
              <Typography variant="body1" textAlign="left">
                {selectedView?.refTreatmentPlan}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <Typography variant="subtitle2" textAlign="left">
                Treatment Status <br />
              </Typography>
              <Typography variant="body1" textAlign="left">
                {selectedView?.treatmentStatus ? selectedView?.treatmentStatus : 'Completed'}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <Typography variant="subtitle2" textAlign="left">
                Payment Received <br />
              </Typography>
              <Typography variant="body1" textAlign="left">
                {selectedView?.paymentReceived}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: '10px' }}>
            <Grid item xs={6} sm={4} md={4}>
              <Typography variant="subtitle2" textAlign="left">
                Payment Mode <br />
              </Typography>
              <Typography variant="body1" textAlign="left">
                {selectedView?.paymentMode}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <Typography variant="subtitle2" textAlign="left">
                Balance <br />
              </Typography>
              <Typography variant="body1" textAlign="left">
                {selectedView?.balance}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewDialog}>
            <Typography color="#66b5a3">Cancel</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AccountViewDialog;
